module.exports = __webpack_public_path__ + "static/img/plutoCharacter.1606419.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plutoCharacter.png
// module id = vjiA
// module chunks = 11